import React, { FC } from 'react';
import * as styles from './AuthTemplateFooter.module.scss';

const AuthTemplateFooter: FC = ({ children }) => {
  return <div className={styles.footer}>{children}</div>;
};

export default AuthTemplateFooter;
